import { useQuery } from "react-query";
import HistoryService from "@/services/history.service";

export const useHistory = (page: number, searchQuery: string, deckId: string, quizId: string) => {
    return useQuery({
        queryKey: ["history", page, searchQuery, deckId, quizId],
        queryFn: () => HistoryService.getHistoryByDeckId({ page, limit: 10, search: searchQuery, deckId: deckId, quizId: quizId }).then(res => res.data),
        keepPreviousData: true,
        staleTime: 1000 * 5,
        retry: false, 
    });
};